import type { TDatadogErrorLog } from 'utils/datadog/types'

import type { TStarIcons } from './favorite.types'

export const starIcon: TStarIcons = {
  md: {
    active: 'starFilled',
    inactive: 'starOutline',
  },
  sm: {
    active: 'starFilledSmall',
    inactive: 'starOutlineSmall',
  },
}

export const GET_TERRITORIES_FAVORITE_TOTAL_LOG: TDatadogErrorLog = {
  from: 'src/modules/territory/favorite/favorite.consts.ts',
  name: 'Get the total of favorited territories',
  message: 'Fetch territories favorite total failed',
}

export const GET_FAVORITE_TERRITORIES_MUTATION_LOG: TDatadogErrorLog = {
  from: 'src/modules/territory/favorite/favorite.consts.ts',
  name: 'Get favorite territories mutation',
  message: 'Failed to execute favorite territories mutation',
}
